<template>
<m-pageframe
  :title="title"
  :color="pageframe_color"
  v-resize="onResize"
>
  <template 
    v-slot:title
  >

    <div
            :class="{ left_header_area: true, left_header_area_clickable: true }"
            :style="color_title_bar"
            v-show="show_conversation_summaries"
            v-on:click="onStartSwitchActiveEmployeeEndpoint"
        >
          <v-icon
            style="margin-right: 10px"
          >
            mdi-account-convert
          </v-icon>

          <v-tooltip 
            open-delay="500"
            bottom
          >
            <template v-slot:activator="{ on, attrs }">
              <span v-on="on" v-bind="attrs" :style="{'position': 'relative', 'top': show_active_user ? '-4px' : '0px' }">
               {{title}}
               <div
                style="font-size: 9px; margin-left: 40px; margin-top: -3px;"
                v-if="show_active_user"
               >
                {{$rc.$state.profile.employee_label}}
              </div>
              </span>
            </template>
            <span>{{pretty_active_endpoint}}</span>
          </v-tooltip>
        </div>

        <div
            class="right_header_area"
            :style="color_title_bar"
        >
          <v-icon
            v-show="!show_conversation_summaries"
            v-on:click="showConversationSummaries"
            style="margin-right: 0px"
          >
            mdi-arrow-left
          </v-icon>
          <div
            style="display: inline; cursor: pointer;"
            v-on:click="onClickRightTitleBarArea"
          >
            {{sub_title}}
          </div>
        </div>
  </template>

    <m-conversation-summaries
                ref="summary_pane"
                v-on:select-conversation="userSwitchConversation"
                v-on:start-new-chat="onStartNewChat"
                v-on:conversation-action="onConversationAction"
                v-on:menu-action="onMenuAction"
                v-on:exit-dnd="onExitDND"
                v-on:clear-selected-conversation="onClearConversation"
                :start_conversation_button_color = "pageframe_color"
                v-show="show_conversation_summaries"
                :can_transmit="can_transmit"
                :ad_hoc_dnd="ad_hoc_dnd"
                :cur_display_mode="cur_display_mode"
                :show_archived_conversations="show_archived_conversations"
                :show_active_conversations="show_active_conversations"
                :show_spam_conversations="show_spam_conversations"
                :show_read_conversations="show_read_conversations"
                :participant_state="participant_state"
                :message_content_full_text_search="message_content_full_text_search"
                :message_tag_search="message_tag_search"
                :show_unread_conversations="show_unread_conversations"
                :organization_id="organization_id"
            />

    <m-conversation
          ref="conversation_pane"
          v-on:send-message="onSendMessage"
          v-on:compose-attachment="onComposeAttachment"
          v-on:customize-intro="onCustomizeIntro"
          v-on:compose-message="onComposeMessage"
          v-on:schedule-message="onScheduleMessage"
          v-on:search-saved-messages="onSearchSavedMessages"
          v-on:show-payment-request-dialog="onShowPaymentRequestDialog"
          v-on:show-start-outbound-call-dialog="onShowStartOutboundCallDialog"
          v-on:start-entering-text="onStartEnteringText"
          v-on:exit-dnd="onExitDND"
          :show_message_controls="show_message_controls"
          :for_endpoint="active_endpoint"
          :org_endpoint="org_endpoint"
          :can_transmit="can_transmit"
          :ad_hoc_dnd="ad_hoc_dnd"
          v-on:message-details="onShowMessageDetails($event)"
          v-on:test-message="onShowTestMessageDialog()"
          v-on:create-saved-message="onCreateSavedMessage"
          v-on:bulk-message-set-outcome="onBulkMessageSetOutcome"
          v-on:import-vcard="onImportVCard"
          v-on:edit-scheduled-message="onEditScheduledMessage"
          :sub_title="sub_title"
          :no_conversation_selected="no_conversation_selected"
          v-on:change-offset="onChangeOffset"
        />

<m-autocomplete-phone-number
    ref="start-new-chat-dialog"
    dialog_only
    v-on:input="onStartConversation"
    v-on:start-group-text="onStartMultiConversation"
    :organization_id="summaries == null ? null : summaries.organization_id"
    :disable_group_text="active_endpoint_sub_type == 'ptsn-toll-free'"
/>

<m-reply-to-customer-dialog
   ref="reply-to-customer-dialog"
   v-on:send-text-to-start-chat="onSendTextToStartChat"
/>

<m-edit-contact-dialog
  ref="edit-contact-dialog"
  v-on:ok="onUpsertContact"
/>

<m-edit-blobs-dialog
   ref="compose-attachment-dialog"
   v-on:ok="onSendTextWithAttachment"
   title="Send File(s)"
   show_with_message
   show_with_vcard
   :for_endpoint="active_endpoint"
/>

<m-search-saved-messages-dialog
  ref="search-saved-messages-dialog"
  v-on:send-and-edit="onSendAndEditSavedMessage"
  v-on:send="onSendSavedMessage"
  v-on:click-introductions="onClickIntroductionMessage"
/>

<m-select-employee-endpoint-dialog
  ref="select-endpoint-dialog"
  :selected_endpoint="active_endpoint"
  v-on:select-endpoint="onSwitchEndpoint"
/>

<m-payment-request-dialog
  ref="payment-request-dialog"
  v-on:ok="sendPaymentRequest($event)"
/>

<m-start-outbound-call
  ref="start-outbound-call"
  v-on:ok="onStartOutboundCall"
/>

<m-eula-sign-dialog
      ref="m-eula-sign-dialog"
  />

<m-using-ie-dialog
  ref="using-ie-dialog"
/>

<m-message-details-dialog
  ref="message-details-dialog"
/>

<m-test-messages-dialog
  ref="test-messages-dialog"
/>

 <m-dialog-admin-link-to-conversation
  ref="dialog-admin-link-to-conversation"
 />

 <m-compose-message-dialog
  ref="dialog-compose-message"
  v-on:ok="onSendMessage"
 />

 <m-schedule-message-dialog
  ref="dialog-schedule-message"
  v-on:ok="doScheduleMessage"
 />

 <m-saved-message-dialog
   ref="saved-message-dialog"
   v-on:ok="onUpsertSavedMessage"
 />

 <m-bulk-outcome-change-dialog
   ref="change-outcome-dialog"
   v-on:ok="afterSetBulkMessageOutcome"
 />



 <m-dialog-change-spam-state
  ref="change-spam-state"
  v-on:ok="afterChangeSpamState"
 />

 <m-auto-message-review-dialog
  ref="auto-message-review-dialog"
/>


 <m-phone-number-validation-details-dialog
    ref="validation-details-dailog"
  />


    <v-snackbar
      v-model="message_alert_snackbar"
      top
      :timeout="4000"
    >
        {{ message_alert_snackbar_text }}


        <v-btn
            dark
            text
            @click="message_alert_snackbar = false; message_alert_snackbar_go();"
            style="color: white"
            >
            Go
        </v-btn>
    </v-snackbar>

</m-pageframe>
</template>

<script>
const ConversationSummaries = require('@/js/ConversationSummaries.js');
const E164 = require('@/js/E164.js');
const Device = require('@/js/device.js');
const { v4: uuidv4 } = require('uuid');

export default {

  data() {
    return {
      sub_title: '',

      organization_id: null,
      conversation_id: null,
      active_endpoint: null,
      active_endpoint_type: null,
      active_endpoint_sub_type: null,
      org_endpoint: null,

      endpoint_index: 0,

      conversation_obj: null,

      endpoint_select_menu_items: [ { text: 'foo' }],
      pageframe_color: "primary",

      cur_display_mode: 'desktop',

      message_alert_snackbar: false,
      message_alert_snackbar_text: '',
      message_alert_snackbar_go: null,
      summaries: null,
      ad_hoc_dnd: null,

      show_conversation_states: ['active'],
      show_read_conversations: true,
      show_unread_conversations: true,

      show_archived_conversations: false, 
      show_active_conversations: true, 
      show_spam_conversations: false,
      participant_state: 'any',
      message_content_full_text_search: null,
      message_tag_search: null,
    }
  },

  beforeRouteUpdate(to, from, next) 
  {
    next();

    this.setupPage(to);
  },

  beforeRouteLeave(to, from, next)
  {
    next();

    if ( to.name == 'home-routed' )
    {
      this.setupPage(to);
    }
  },

  created () {
    this.$event_bus.$off('update-conversation-summaries');
    this.$event_bus.$off('update-conversation');
    this.$event_bus.$off('conversation-not-found');

    this.$event_bus.$on('update-conversation-summaries', this.onUpdateConversationSummaries);
    this.$event_bus.$on('update-conversation', this.onUpdateConversation);
    this.$event_bus.$on('conversation-not-found', this.onConversationNotFound);

    this.$event_bus.$off('show-message-alert');
    this.$event_bus.$on('show-message-alert', this.onShowMessageAlert);

    this.$event_bus.$on('upsert-contact-request', this.onContactRequestNotice);
    this.$event_bus.$on('common-update-employee-dnd', this.checkDNDStatus);
  },

  beforeDestroy () {
    this.$event_bus.$off('update-conversation-summaries',this.onUpdateConversationSummaries);
    this.$event_bus.$off('update-conversation',this.onUpdateConversation);
    this.$event_bus.$off('conversation-not-found',this.onConversationNotFound);
    this.$event_bus.$off('show-message-alert', this.onShowMessageAlert);
    this.$event_bus.$off('upsert-contact-request',this.onContactRequestNotice);
    this.$event_bus.$off('common-update-employee-dnd', this.checkDNDStatus);
  },

  mounted () 
  {
    this.setupPage(this.$route); 

    let has_shown_ie_warning = window.sessionStorage.getItem('hasShownIEWarning');

    if (!has_shown_ie_warning && this.$refs['using-ie-dialog'].checkIfIE())
    {
      this.$refs['using-ie-dialog'].showDialog();
      window.sessionStorage.setItem('hasShownIEWarning',true);
    }

    this.checkDNDStatus();
    this.checkAutoMessagesNeedReview();

  },

  methods: 
  {
    checkAutoMessagesNeedReview()
    {
      this.$rc.rest({
        'spinner': false,
        'endpoint': 'GET: /api/v1/legal/auto-messages-in-need-of-review/:organization_id',
      
        'params' : {
            'organization_id': this.$rc.$state.profile.employee_account.organization_id,
          },
      
        'on_success': (data) => {
            if ( !data.review_required )
              return;

            this.$refs['auto-message-review-dialog'].showDialog();

          },
      
        'on_error': () => {},
      });
    },

    onClearConversation()
    {
      this.userSwitchConversation('none');
    },

    setupPage(route)
    {
      this.offset = 0;
      this.limit = 100;

      this.active_endpoint = E164.fullEndpoint(route.params.endpoint);
      this.$rc.$ably.subscribe(this.active_endpoint);
      this.conversation_id = route.params.conversation_id != 'none' ? route.params.conversation_id : null; 

      this.setPageframeColor();

      this.onResize();

      this.$rc.getConversationSummaries(this.active_endpoint, this.show_conversation_states, this.show_read_conversations, this.show_unread_conversations, this.participant_state, this.message_content_full_text_search, this.message_tag_search);

      if ( this.conversation_id != null )
      {
        this.$rc.updateConversation(this.conversation_id, this.offset, this.limit);
        this.$rc.setConversationRead(this.active_endpoint, this.conversation_id,true);
      }

      // this.$rc.updateOrganizationProfileFromServer();

      this.$rc.checkEULA(
          (eula_check) => {

            if ( eula_check.signature_current ) return;

            this.$refs['m-eula-sign-dialog'].showDialog(this.$rc.$state.employee_id);
          }
      );
    },

    setPageframeColor()
    {
      let endpoints = this.$rc.$state.getEmployeeEndpoints();

      this.pageframe_color = '#5D647C';

      for ( let i = 0; i < endpoints.length; i++ )
      {
        let cur_endpoint = endpoints[i].endpoint;

        if ( cur_endpoint == null ) continue;
        
        if ( cur_endpoint.includes(this.active_endpoint) ) 
        {
          this.pageframe_color = '#F24653';
          return;
        }
      }

    },

    onResize()
    {
      let new_display_mode = window.innerWidth < 960 ? 'mobile' : 'desktop';
      if ( new_display_mode === this.cur_display_mode ) return;

      this.cur_display_mode = new_display_mode;
      this.$forceUpdate();
    },

    retrieveConversationSummaries()
    {
      let include_states = [];
      
      if ( this.show_active_conversations ) include_states.push('active');
      if ( this.show_archived_conversations ) include_states.push('archived');
      if ( this.show_spam_conversations ) include_states.push('spam');

      this.show_conversation_states = include_states;
      
      this.$rc.getConversationSummaries(this.active_endpoint, this.show_conversation_states, this.show_read_conversations, this.show_unread_conversations, this.participant_state, this.message_content_full_text_search, this.message_tag_search);
    },

    onUpdateConversationSummaries(summaries)
    {
      if ( summaries.getForEndpoint() != this.active_endpoint )
        return;

      if ( summaries.limited_by_message_privacy_controller )
      {
        this.$rc.confirm(
          'Not authorized',
          'You are not authorized to read messages on this phone number.  You will be switched back to your home endpoint.',
          [
            {'text': 'Ok', 'value': 'ok'},
          ],
        
          (response) => {
              this.$router.push({
                'name': 'home',
              });
          }
        );
      }

      this.summaries = summaries;
      this.organization_id = summaries.organization_id;
      this.org_endpoint = summaries.org_endpoint;
      this.active_endpoint_type = summaries.endpoint_type;
      this.active_endpoint_sub_type = summaries.endpoint_sub_type;

      this.$refs['summary_pane'].update(summaries);
      this.$refs['summary_pane'].setSelectedConversationId(this.conversation_id);
      
      this.sub_title = this.getSubTitle();
      this.updateTitle(summaries);
    },

    updateTitle(summaries)
    {
      let total = 0;

      if ( summaries.getOpenContactRequestInfo() )
      {
        total += summaries.getOpenContactRequestInfo().open_contact_requests;
      }

      if ( summaries.getTeamCountSummaries() )
      {
        for ( let i=0; i < summaries.getTeamCountSummaries().length; i++ )
        {
          let team_summary = summaries.getTeamCountSummaries()[i];

          if ( !team_summary.team_endpoint ) continue;

          total += team_summary.count_unclaimed;
          total += team_summary.count_claimed_by_employee_and_unread;
        }
      }

      // now add all the unread_conversations
      for ( let i=0; i < summaries.data.length; i++ )
      {
        let conversation_summary = summaries.data[i];

        if ( !conversation_summary.data.read && !conversation_summary.data.archived )
        {
          total++;
        }
      }

      if ( !this.$rc.$state.isAuthActorSystemAdmin() )
      {
        if ( total == 0 )
        {
          document.title = 'RedChirp';
        }
        else
        {
          document.title = 'RedChirp (' + total + ')';
        }
      }
    },

    getSubTitle()
    {
      if ( this.conversation_id == null ) return '';
      if ( this.active_endpoint == null ) return '';

      // First, try and find the conversation summary
      let summary = this.$rc.$state.findConversationSummary(this.conversation_id,null);
      if ( summary != null ) 
        return summary.label_line;
      
      let params = {
        'active_endpoint' : this.active_endpoint,
        'conversation_id' : this.conversation_id,
      };

      // Fetch via api
      this.$rc.getConversationLabel(
        params,
      
        (data) => {
          this.sub_title = data.label;
        },
      
        () => {
        },
      );

      // but immediately return blank (will be set once the API call returns...)
      return '';
    },

    onContactRequestNotice()
    {
      this.retrieveConversationSummaries();
    },

    onUpdateConversation(conversation)
    {
      if ( conversation == null || conversation.getConversationId() !== this.conversation_id ) return;

      this.conversation_obj = conversation;

      this.$refs['conversation_pane'].update(conversation);
      this.$refs['summary_pane'].setSelectedConversationId(this.conversation_id);

      
      this.sub_title = this.getSubTitle();

      window.setTimeout(
        () =>{ this.$refs['conversation_pane'].scrollConversationToBottom(); }, 
        350
      );
    },

    userSwitchConversation(new_conversation_id)
    {
      let endpoint = this.active_endpoint.substring("E164:+".length);

      this.$router.push({
          'name': 'home-routed', 
          params: { 
            'conversation_id' : new_conversation_id,
            'endpoint' : endpoint,
          }
      })
      .catch(e=>{}); // swallow any exception
    },

    checkDNDStatus() {
      this.$rc.getAdHocDND(
          this.$rc.$state.profile.employee_account.employee_id,
          (data) => {
              if (data.ad_hoc_dnd && data.ad_hoc_dnd != '')
              {
                  this.ad_hoc_dnd = data.ad_hoc_dnd;
              }
              else
              {
                  this.ad_hoc_dnd = null;
              }
          },
      );
    },


    onExitDND()
    {
        let info = {
            'employee_id' : this.$rc.$state.profile.employee_account.employee_id,
            'organization_id' : this.$rc.$state.profile.employee_account.organization_id,
        };

        this.$rc.exitAdHocDND(
            info,
            (data) => {
                this.ad_hoc_dnd = null;
            },
            () => {
                this.$rc.alert("Error with DND", "Unable to Stop Ad Hoc Do Not Disturb");
            }
        );
    },

    onStartEnteringText()
    {
      this.$refs['conversation_pane'].focusOnTextBox();
    },

    onSendMessage(text)
    {
      if ( this.conversation_id === null ) 
          return;

      let to_send = {
        'active_endpoint': this.active_endpoint, 
        'conversation_id': this.conversation_id, 
        'text': text.trim(), 
        'blob_ids': null, 
        'send_images_as_links': null,
        'category': 'conversational'
      };
      
      this.$rc.sendMessage(to_send);
    },

    doScheduleMessage(params)
    {
      this.$rc.rest({
        'spinner': false,
        'endpoint': 'POST: /api/v1/messages/schedule-message',
      
        'params' : {
          ...params,
          'from': this.active_endpoint, 
          'conversation_id': this.conversation_id, 
        },
      
        'on_success': (data) => {
          },
      
        'on_error': 'Unable to schedule message',
      });
    },

    onEditScheduledMessage(message)
    {
      this.$refs['dialog-schedule-message'].showDialog({'text': message.getContentAsObject().text, 'send_time': message.getTime(), 'stored_message_id': message.getId()});
    },

    onSendTextWithAttachment(send_data)
    {
      let blob_ids = send_data.blob_ids;
      let with_message = send_data.with_message;

      if ( this.conversation_id === null ) 
        return;

      let to_send = {
        'active_endpoint': this.active_endpoint, 
        'conversation_id': this.conversation_id, 
        'text': with_message, 
        'blob_ids': blob_ids, 
        'send_images_as_links': this.$refs['compose-attachment-dialog'].getSendImagesAsLinks(),
        'category': 'conversational',
        'vcard_id': send_data.vcard_id,
      };

      this.$rc.sendMessage(to_send);
    },

    onCustomizeIntro(send_data)
    {
      this.$refs['compose-attachment-dialog'].showDialog(send_data.blob_ids, true, send_data.message);
    },

    onStartNewChat()
    {
      this.$refs['start-new-chat-dialog'].showDialog();
    },

    onUpdateUnreadCounts()
    {
      this.$rc.rest({
        'spinner': true,
        'endpoint': 'GET: /api/v1/conversations/update-unread-counts/:organization_id',
        'timeout': 30000,
      
        'params' : {
            'organization_id': this.organization_id, 
          },
      
        'on_success': (data) => {
            location.reload();
          },
      
        'on_error': 'Unable to update unread conversation counts',
      });
    },

    onStartMultiConversation(numbers)
    {
      if ( numbers == null || numbers.length == 0 ) return;

      let other_endpoints = [];

      for ( let i = 0; i < numbers.length; i++ )
      {
        other_endpoints.push(numbers[i].value);
      }

      let params = {
        'active_endpoint' : this.active_endpoint,
        'other_endpoints' : other_endpoints,
      };

      if ( other_endpoints.length > 1 )
      {
        this.$rc.warn({
          'warning_code': 'everyone_receives_group_messages',
          'title': 'Warning: Group Message',
          'text': 'You are about to start a group message.  In a group message, <b>each participant will see every response sent.</b> (i.e.  everyone will see everyone else\'s messages)<br/><br/>If you would like to message a group of people, but have a <b>separate</b> conversation with each participant, <b>send a bulk message instead.</b>',
          'label_ok': 'Start Group Message',
          'label_dismiss': 'Do not show again',
          'label_cancel': 'Cancel',
        
          'on_ok': () => {
            this.onStartConversationImpl(params);
          },

          'on_cancel': () => {
            this.userSwitchConversation('none');
          },
        });
      }
      else
      {
        this.onStartConversationImpl(params);
      }

      
    },

    onStartConversation(number)
    {
      let params = {
        'active_endpoint' : this.active_endpoint,
        'other_endpoints' : [number.value],
      };

      this.onStartConversationImpl(params);
    },

    onStartConversationImpl(params)
    {
      this.$rc.showSpinner();

      this.$rc.getOrCreateConversationDefinition(
        params,

        (data) => {
          this.$rc.hideSpinner();

          this.userSwitchConversation(data.conversation_id);

          this.$refs['conversation_pane'].focusOnTextBox();
        },

        () => {
          this.$rc.hideSpinner();
          this.$rc.alert('Error','Unable to start conversation');
        },
      );
    },

    onSendTextToStartChat(message)
    {
      this.$rc.showSpinner();

      this.$rc.sendMessageToStartChat(
        this.active_endpoint, 
        message.to, 
        message.text,

        (data) => {
          this.$rc.hideSpinner();

          this.userSwitchConversation(data.conversation_summary.conversation_id);
        },

        () => {
          this.$rc.hideSpinner();
          this.$rc.alert('Error', 'Unable to start new conversation');
        }
      );
    },

    onUpsertContact(new_contact)
    {
      this.$rc.upsertContact(new_contact);
    },

    onMenuAction(item)
    {
      if (item.action == 'toggle_archived_conversations')
      {
        this.show_active_conversations = false;
        this.show_archived_conversations = true;
        this.show_spam_conversations = false;
        this.retrieveConversationSummaries();
        return;
      }

      if (item.action == 'toggle_active_conversations')
      {
        this.show_active_conversations = true;
        this.show_archived_conversations = false;
        this.show_spam_conversations = false;
        this.retrieveConversationSummaries();
        return;
      }

      if (item.action == 'toggle_spam_conversations')
      {
        this.show_active_conversations = false;
        this.show_archived_conversations = false;
        this.show_spam_conversations = true;
        this.retrieveConversationSummaries();
        return;
      }

        if (item.action == 'toggle_read_conversations')
        {
            this.show_read_conversations = !this.show_read_conversations;
            this.retrieveConversationSummaries();
            return;
        }

        if (item.action == 'toggle_unread_conversations')
        {
            this.show_unread_conversations = !this.show_unread_conversations;
            this.retrieveConversationSummaries();
            return;
        }

        if ( item.action == 'filter_participant' )
        {
          this.participant_state = item.value;
          this.retrieveConversationSummaries();
          return;
        }

        if ( item.action == 'message_content_full_text_search' )
        {
          this.message_content_full_text_search = item.value;
          this.message_tag_search = null;
          this.retrieveConversationSummaries();
          return;
        }

        if ( item.action == 'message_tag_search' ) 
        {
          this.message_content_full_text_search = null;
          this.message_tag_search = item.value;
          this.retrieveConversationSummaries();
          return;
        }
        
      if (item.action == 'start_new_chat')
      {
        this.onStartNewChat();
        return;
      }

      if ( item.action == 'message_contact_search')
      {
        this.onStartNewChat();
        return;
      }

      if ( item.action == 'update_unread_counts' )
      {
        this.onUpdateUnreadCounts();
        return;
      }
    },

    onSwitchEndpoint(endpoint)
    {
      this.$rc.toHomeForEndpoint(this.$router, endpoint, false);
    },

    onConversationAction(action)
    {
      if ( action.action === 'set_read' )
      {
        this.$rc.setConversationRead(this.active_endpoint, action.conversation_id,action.read_value);
        return;
      }

      if ( action.action == 'edit_tags' )
      {
        this.$rc.change_tags_dialog({
            'organization_id': this.organization_id,
            'applies_to': 'conversation',
            'selected_tag_ids': action.rc_tag_ids,
            'show_archived': false,
            'on_save': (ids) => {
               
               
               this.$rc.rest(
                'PUT: /api/v1/conversation-summaries/set-tags',
               
                {
                  'endpoint': this.active_endpoint,
                  'conversation_id': action.conversation_id,
                  'rc_tag_ids': ids,
                },
               
                (data) => {
                },
               
                () => {
                  this.$rc.alert('Error','Unable to tag conversation');
                },
               );

            }
        });
      }

      if ( action.action === 'set_conversation_state' )
      {
        this.$rc.showSpinner();
                
          this.$rc.rest(
              'PUT: /api/v1/conversations/set-state',
          
              {
                  'endpoint' : this.active_endpoint,
                  'conversation_id' : action.conversation_id,
                  'state' : action.new_state,
              },
          
              (data) => {
                  this.$rc.hideSpinner();
                  this.retrieveConversationSummaries();
              },
          
              () => {
                  this.$rc.hideSpinner();
                  this.$rc.alert('Error','Unable to modify conversation');
              },
          );

        return;
      }

      if ( action.action === 'archive_all_conversations_older_than' )
      {
          this.$rc.confirm(
            'Archive all conversations older than this one',
            'Archive all conversations older than the selected conversation.<br/><br/>This can not be undone.',
            [
              {'text': 'Cancel', 'value': 'cancel'},
              {'text': 'Confirm', 'value': 'confirm'},
            ],
          
            (response) => {
              if (response != 'confirm') return;
              
              this.$rc.showSpinner();
              
              this.$rc.rest(
                'PUT: /api/v1/conversations/archive-older-than',
              
                {
                   'endpoint' : this.active_endpoint,
                   'conversation_id' : action.conversation_id,
                },
              
                (data) => {
                  this.$rc.hideSpinner();
                  this.retrieveConversationSummaries();
                },
              
                () => {
                  this.$rc.hideSpinner();
                  this.$rc.alert('Error','Unable to archive conversations.');
                },
              );
            }
          );
      }

      if ( action.action === 'change_spam_state' )
      {
        let is_spam = action.is_spam;
        let conversation_id = action.conversation_id;

        this.$refs['change-spam-state'].showDialog(is_spam, conversation_id);
        return;
      }

      if ( action.action === 'admin_link_to_conversation' )
      {
        this.$refs['dialog-admin-link-to-conversation'].showDialog(action.endpoint, action.conversation_id);
      } 

      if ( action.action === 'edit_label' )
      {
        this.$rc.getContactByEndpoint(action.endpoint, this.showEditContactDialog);
        return;
      }
    },

    showEditContactDialog(contact)
    {
      this.$refs['edit-contact-dialog'].showDialog(contact);
    },

    onStartSwitchActiveEmployeeEndpoint()
    {
      this.$refs['select-endpoint-dialog'].showDialog();
    },

    onComposeAttachment(cur_text)
    {
      this.$refs['compose-attachment-dialog'].showDialog([],true,cur_text);
    },

    onComposeMessage(cur_text)
    { 
      this.$refs['dialog-compose-message'].showDialog(cur_text);
    },

    onScheduleMessage(cur_text)
    {
      this.$refs['dialog-schedule-message'].showDialog({'text': cur_text, 'send_time': null, 'stored_message_id': null, 'with': this.sub_title});
    },

    // saved message functions
    onSearchSavedMessages()
    {
      this.$refs['search-saved-messages-dialog'].showDialog(this.$rc.$state.profile.employee_account.organization_id);
    },

    onImportVCard(message)
    {
      let data = message.getContentAsObject();

      this.$rc.confirm(
        'Import Contact',
        'Do you want to import the information from this VCard? Existing contacts will be updated.',
        [
          {'text': 'Cancel', 'value': 'cancel'},
          {'text': 'Confirm', 'value': 'confirm'},
        ],
        (response) => {
          if (response == 'confirm') {
            this.$rc.showSpinner();
            this.onImportVCardImpl(data);
          } else {
            return;
          }
        }
      );
    },

    onImportVCardImpl(vcard_data)
    {
      this.$rc.putImportVCard(
        this.$rc.$state.profile.employee_account.organization_id,
        vcard_data,
        (data) => {
          this.$rc.hideSpinner();
          this.$rc.snackbar(
              'Contact Imported',
              3000
          );
        },
        () => {
          this.$rc.hideSpinner();
          this.$rc.alert(
            'Error Import VCard Information',
            'There was an error importing the VCard information. Please try again.'
          );
        }
      );

    },

    onBulkMessageSetOutcome(message)
    {
      this.$rc.getBulkMessageOutcomesFromRecipientId(
        message.data.bulk_message_recipient_id,
        (data) => {
          let recipient_id = data.recipient.bulk_message_recipient_id;
          let selected_outcome_id = data.recipient.outcome_id;

          let outcomes = [{ 'text' : 'Not Selected', 'value' : null}];

          for ( let i = 0; i < data.outcomes.length; i++ )
          {
            outcomes.push({
              'text' : data.outcomes[i].label,
              'value' : data.outcomes[i].outcome_id,
            });
          }

          this.$refs['change-outcome-dialog'].showDialog(
            recipient_id,
            selected_outcome_id,
            outcomes
          );
        },
        () => {
          this.$rc.alert(
            'Error Changing Outcome',
            'Could not change the outcome for this bulk message. Please try again.'
          );
        }
      );
    },

    afterSetBulkMessageOutcome(recipient_id, new_outcome_id)
    {
      this.$rc.updateBulkRecipientOutcome(
        recipient_id,
        new_outcome_id,
      );
    },

    onCreateSavedMessage(saved_message_content)
    {
      if ( !saved_message_content ) 
        return;

      let saved_message = {
        'organization_id' : this.$rc.$state.profile.employee_account.organization_id,
        'saved_message_id' : uuidv4(),
        'authored_by_employee_id' : this.$rc.$state.profile.employee_account.employee_id,
        'limit_to_employee_id' : this.$rc.$state.profile.employee_account.employee_id,
        'available_to_all_team_members' : false,
        'creation_time' : Date.now(),
        'content_type' : 'text/plain',
        'message_patterns' : [saved_message_content],
        'title' : null,
      };

      this.onEditSavedMessage(saved_message);
    },

    onEditSavedMessage(saved_message)
    {
      this.$refs['saved-message-dialog'].showDialog(saved_message);
    },

    onUpsertSavedMessage(saved_message)
    {
      this.$rc.showSpinner();

      this.$rc.putSavedMessage(
        saved_message,
        (data) => {
          this.$rc.hideSpinner();

          this.$rc.snackbar('Saved message created', 3000);
          this.doSearch();
        },
        () => {
          this.$rc.alert(
            "Failed to create Saved Message",
            "There was an error creating the Saved Message, please try again."
          );
        },
      );
    },

    onSendAndEditSavedMessage(saved_message)
    {
      this.$rc.instantiateSavedMessage(
        this.organization_id,
        saved_message.saved_message_id,
        this.conversation_id,
        this.active_endpoint,
        (data) => {
          if (saved_message.blob_ids.length > 0 || null != saved_message.vcard_id)
          {
            // Has attachments or vcard -> Reroute to "Send pictures or files..."
            this.$refs['compose-attachment-dialog'].showDialog(saved_message.blob_ids,true,data.result,saved_message.vcard_id);
          }
          else
          {
            this.$refs['conversation_pane'].setCurrentText(data.result);
          }
        },
        () => {
          this.$rc.alert(
            'Error Retrieving Saved Message',
            'There was an error retrieving the Saved Message. Please try again.',
          );
        },
      );
    },

    onSendSavedMessage(saved_message)
    {
      this.$rc.instantiateSavedMessage(
        this.organization_id,
        saved_message.saved_message_id,
        this.conversation_id,
        this.active_endpoint,
        (data) => {
          if (saved_message.blob_ids.length > 0 || null != saved_message.vcard_id)
          {
            // Same as after "Send pictures or files..."
            this.onSendTextWithAttachment({
              'blob_ids' : saved_message.blob_ids,
              'with_message' : data.result,
              'vcard_id': saved_message.vcard_id,
            });
          }
          else
          {
            this.onSendMessage(data.result);
          }
/*


this.$emit('ok', {
                    'blob_ids' : blob_ids,
                    'with_message' : with_message,
                    'vcard_id': this.vcard_id,
                });
*/
        },
        () => {
          this.$rc.alert(
            'Error Retrieving Saved Message',
            'There was an error retrieving the Saved Message. Please try again.',
          );
        },
      );
    },

    

    onShowPaymentRequestDialog()
    {
      this.$refs['payment-request-dialog'].showDialog();
    },

    showConversationSummaries()
    {
      this.$router.push({
          'name': 'home-routed', 
          params : {
            'active_endpoint' : this.active_endpoint,
            'conversation_id' : 'none'
          }
      })
      .catch(e=>{}); // swallow any exception
    },

    onShowStartOutboundCallDialog()
    {
      if ( this.conversation_id === null ) 
        return;

      this.afterNonOwnedGateShowStartOutboundCallDialog();
    },

    afterNonOwnedGateShowStartOutboundCallDialog() 
    {
      let endpoints = this.conversation_obj.getConversationEndpoints();
      let target_endpoint = null;
      let organization_endpoint = this.active_endpoint;

      for ( let i = 0; i < endpoints.length; i++ )
      {
        if ( endpoints[i] != organization_endpoint )
        {
          target_endpoint = endpoints[i];
          break;
        }
      }

      this.$refs['start-outbound-call'].showDialog(organization_endpoint, target_endpoint);
    },

    onStartOutboundCall()
    {
      alert('start call!');
    },

    onConversationNotFound()
    {
      this.$router.push({ 
          name: 'error-conversation-not-found',
          params: {
            'conversation_id' : this.conversation_id
          }
        });
    },

    onShowMessageAlert(alert_data)
    {
        if ( alert_data.endpoint == this.active_endpoint )
          return;

        this.message_alert_snackbar_text = alert_data.show_silent_notification;
        this.message_alert_snackbar = true;

        this.message_alert_snackbar_go = () => {
          this.$router.push({
                'name': 'home-routed', 
                params: { 
                  'conversation_id' : alert_data.conversation_id,
                  'endpoint' : alert_data.endpoint,
                }
            })
            .catch(e=>{}); // swallow any exception
        };
    },

    sendPaymentRequest(post_data)
    {
      post_data.active_endpoint = this.active_endpoint;
      post_data.conversation_id = this.conversation_id;

      this.$rc.rest({
        'spinner': false,
        'endpoint': 'SEND: /api/v1/payments',
      
        'params' : post_data,
      
        'on_success': (data) => {},
      
        'on_error': 'Unable to send payment request',
      });
    },

    onShowMessageDetails(stored_message_id)
    {
      this.$refs['message-details-dialog'].showDialog(stored_message_id);
    },

    onShowTestMessageDialog()
    {
      this.$refs['test-messages-dialog'].showDialog(this.active_endpoint, this.conversation_id);
    },

    onClickRightTitleBarArea()
    {
      if ( this.active_endpoint == null || this.conversation_id == null )
        return;


      this.$rc.showSpinner();
      
      this.$rc.rest(
        'GET: numbers/endpoint-details-for-conversation/:active_endpoint/:conversation_id',
      
        {
          'active_endpoint': this.active_endpoint,
          'conversation_id': this.conversation_id,
        },
      
        (data) => {
          this.$rc.hideSpinner();

          this.$refs['validation-details-dailog'].showDialog(data.results);
        },
      
        () => {
          this.$rc.hideSpinner();
          this.$rc.alert('Error','Unable to get contact details.');
        },
      );

    },

     afterChangeSpamState(is_spam)
     {
       if ( is_spam )
       {
         this.userSwitchConversation('none');
       }
       this.retrieveConversationSummaries();
     },
 

    onChangeOffset(offset_and_limit)
    {
      this.offset = offset_and_limit.offset;
      this.limit = offset_and_limit.limit;

      this.$rc.updateConversation(this.conversation_id, this.offset, this.limit);
    },

    onClickIntroductionMessage()
    {
      this.$refs['conversation_pane'].onClickSendIntro();
    },
  },

  computed: {

    title() {
      if ( this.$rc.$state.profile == null ) return 'Home';
      
      let endpoints = this.$rc.$state.profile.organization_endpoints;

      // Remove this at some point in the future... fallback...
      if ( endpoints == null ) endpoints = this.$rc.$state.getEmployeeEndpoints(); // this is a fallback -- if someone has not been home then their employee profile is not updated and the old code keyed off of employee endpoints so fallback to that...

      let active_endpoint = this.active_endpoint;

      for ( let i = 0; i < endpoints.length; i++ )
      {
        if ( endpoints[i].endpoint == active_endpoint )
          return endpoints[i].label;
      }

      return 'Unlabled';
    },

    show_active_user()
    {
      return this.$rc.$state.profile.employee_label != this.title;
    },

    can_transmit()
    {
      let can_transmit = this.$rc.$state.canTransmitOn(this.active_endpoint);

      // if it's a team endpoint, any employee can transmit on it
      if ( this.summaries && this.summaries.org_endpoint )
      {
        if ( this.summaries.org_endpoint.assignment == 'assigned-to-employee-group' )
        {
          can_transmit = true;
        }
      }

      return can_transmit;
    },

    show_message_controls()
    {
      if ( this.cur_display_mode === 'desktop' ) 
      {
        if ( this.conversation_id == 'none' || this.conversation_id == null ) return false;
        return true;
      }

      return !this.show_conversation_summaries;
    },

    color_title_bar() {
      return "background-color: "+this.pageframe_color;
    },

    show_conversation_summaries() {
      if ( this.cur_display_mode === 'desktop' )
        return true;
      
      return this.conversation_id == null;
    },

    no_conversation_selected() {
      return this.conversation_id == null || this.conversation_id == 'none';
    },

    pretty_active_endpoint() {
      if ( this.active_endpoint == null ) return '';

      return E164.prettyPrintUsPhoneNumber(this.active_endpoint);
    },
  },
  
};
</script>



<style scoped>

div.title_endpoint
{
  width: 250px; 
  margin-right: 50px; 
  float: left; 
  display: flex; 
  
}

div.active_title_endpoint
{
  cursor: pointer;
}

div.title_endpoint div.title
{
  flex-grow: 1; 
  overflow: hidden; 
  text-overflow: ellipsis;
}

.left_header_area
{
    position: absolute; 
    left: 50px; 
    width: 285px; 
    top: 0; 
    bottom: 0; 
    padding-top: 8px; 
    overflow: hidden;
    z-index: 3;

    background-color: #F24653;

    text-overflow: ellipsis; overflow: hidden; white-space: nowrap;
}



.right_header_area
{
    position: absolute; 
    left: 350px; 
    right: 73px; 
    top: 0; 
    bottom: 0; 
    padding-top: 8px; 
    overflow: hidden;
    z-index: 2;

    background-color: #F24653;

}

@media screen and (max-width: 960px) 
{
    .left_header_area
    {
        width: unset;
        right: 73px;
    }

    .right_header_area
    {
      left: 50px;
    }
}

.left_header_area_clickable
{
  cursor: pointer;
}

</style>